var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdometer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21777 18.1454C1.21777 17.9127 1.21777 17.6978 1.21777 17.4427C1.27978 14.1994 2.61891 11.1097 4.9473 8.83783C7.2757 6.56594 10.4075 5.29321 13.6695 5.29321C16.9315 5.29321 20.0632 6.56594 22.3916 8.83783C24.72 11.1097 26.0592 14.1994 26.1212 17.4427C26.1212 17.6262 26.1212 17.8097 26.1212 17.9888",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H5",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3477 18H25.7151",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6953 11.1845L22.4417 9.59998",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61998 11.1845L4.86914 9.59998",
    stroke: "#003087",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6925 7.2959C12.7123 7.70964 13.0638 8.02898 13.4775 8.00917C13.8912 7.98936 14.2106 7.63789 14.1908 7.22415L12.6925 7.2959ZM14.1908 7.22415L14.0782 4.87428L12.58 4.94603L12.6925 7.2959L14.1908 7.22415Z",
    fill: "#003087"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9054 17.0085C14.9597 17.1701 14.9871 17.3395 14.9864 17.5098C14.9864 17.8232 14.893 18.1296 14.7179 18.3901C14.5428 18.6507 14.294 18.8538 14.0029 18.9737C13.7117 19.0936 13.3914 19.125 13.0823 19.0639C12.7732 19.0027 12.4893 18.8518 12.2665 18.6302C12.0436 18.4087 11.8919 18.1263 11.8304 17.819C11.7689 17.5116 11.8005 17.193 11.9211 16.9035C12.0417 16.614 12.2459 16.3665 12.5079 16.1924C12.7699 16.0183 13.078 15.9254 13.3931 15.9254L17.1964 11.3644L14.9054 17.0085Z",
    stroke: "#EE2A7B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdometer);
export default __webpack_public_path__ + "static/media/odometer.7b609b41.svg";
export { ForwardRef as ReactComponent };